import React from "react";
import Login from "./Login";
import {connect} from "react-redux";
import  {loginMe} from "../../redux/authReducer";

let mapStateToProps = state => ({
        isAuth: state.authPage.isAuth,
        isLoadingStatus:state.authPage.isLoadingStatus
})

const LoginContainer = (props) => {

    return (
        <div>
            <Login {...props}/>
        </div>
    );
};


export default connect(mapStateToProps, {loginMe})(LoginContainer)